import { createSlice } from "@reduxjs/toolkit";
import { galleryService } from "../../services/siteContentService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";


export const getSiteGallery = createCustomAsyncThunk(
    "gallery/get",
    async params => await galleryService.get(params)
)


const siteGallerySlice = createSlice({
    name: "siteGallery",
    initialState: defaultEntityAdapter.getInitialState({
        count: 1,
        isLoading: true,
        error: null
    }),

    extraReducers: builder => {
        builder
            .addCase(getSiteGallery.pending, state => { state.isLoading = true })
            .addCase(getSiteGallery.fulfilled, (state, action) => {
                state.count = action.payload.count
                defaultEntityAdapter.setAll(state, action.payload.results)
                state.isLoading = false
            })
            .addCase(getSiteGallery.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }       
});

export const siteGallerySelector = defaultEntityAdapter.getSelectors(x => x.site.siteGallery)

export default siteGallerySlice.reducer;
